import { createDomain } from 'effector-root';

const domain = createDomain('PNP Logs (Page)');

export const onPageStarted = domain.event();